import { Logger } from '../metrics/logger.js';
import { ContextClassBase } from '../service/RuntimeContext.js';

class Subscription {
    constructor(idx, sbj, hdl) {
        this.index = idx;
        this.subject = sbj;
        this.handler = hdl;
    }
    unsubscribe() {
        this.subject.unsubscribe(this);
    }
}
/** @internal */
class Subject extends ContextClassBase {
    constructor() {
        super(...arguments);
        this.subscriptions = new Map();
        this.idx = 0;
    }
    subscribe(next) {
        // 去重
        const allSubs = this.subscriptions.values();
        for (const sub of allSubs) {
            if (next === sub.handler) {
                Logger.ctxDebug(this.ctx, 'ignore duplicate handler:', next);
                return sub;
            }
        }
        const newSub = new Subscription(this.idx, this, next);
        this.subscriptions.set(this.idx, newSub);
        this.idx++;
        return newSub;
    }
    nextEmpty(sender) {
        for (const sub of this.subscriptions.values()) {
            if (sub && sub.handler) {
                try {
                    sub.handler({}, sender);
                }
                catch (err) {
                    Logger.ctxWarn(this.ctx, 'error in event handler:', err);
                }
            }
        }
    }
    next(value, sender) {
        for (const sub of this.subscriptions.values()) {
            if (sub && sub.handler) {
                try {
                    sub.handler(value, sender);
                }
                catch (err) {
                    Logger.ctxWarn(this.ctx, 'error in event handler:', err);
                }
            }
        }
    }
    unsubscribe(subscription) {
        if (!subscription) {
            return;
        }
        this.subscriptions.delete(subscription.index);
    }
    unsubscribeAll() {
        this.subscriptions.clear();
    }
}

export { Subject, Subscription };
//# sourceMappingURL=Subject.js.map
